import { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { slugCombine } from '../../../utils/slugManager';
import config from "../../../configuration/config";
import { useUserCart } from "../../../User/hooks/useUserCart";
import ConfirmContext from "../../../utils/confirmContext";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Navigation, Autoplay } from "swiper";

SwiperCore.use([Pagination, Navigation, Autoplay]);

export default function HomeVehicleSection({ cars, brands }) {
    const { t: trans, i18n } = useTranslation(["common", "inputs", 'cars', "home", "info"]);
    const lang = (i18n.language || 'ar');
    const [filteredCars, setFilteredCars] = useState(cars);
    const [carFilter, setCarFilter] = useState(null);
    const { changecartItem } = useUserCart();
    const context = useContext(ConfirmContext);

    useEffect(() => {
        setFilteredCars(cars);
    }, [cars]);

    function filterCars(brand) {
        setCarFilter(brand);
        let filterData = [];
        if (brand != null)
            filterData = cars.filter((car) => {
                return car.brand === brand;
            });
        else {
            filterData = cars;
        }
        setFilteredCars(filterData);
    }

    const handleBuyNow = (e, car) => {
        e.stopPropagation();
        try {
            if (car.buyOnline === true) {
                var obb = {
                    ...car,
                    name: car.name,
                    price: car.minPrice,
                    image: car.image,
                    productID: car.productId,
                    id: car.slug,
                    Type: "car",
                    colorId: car.colorID,
                    brand: car.brand,
                    Tax: car.rateTaxCar,
                    Discount: car.rateCareDiscount,
                    year: car.year,
                    modelTypeID: car.type
                };
                changecartItem(car.productId, car.colorID, car.type, 1, null, null, obb, null, car.year);
            } else {
                context.onShow({
                    modelYear: car.year,
                    displayConfirm: true,
                    title: car.name,
                    image: car.image,
                    brand: car.brand,
                    brandID: car.brandID,
                    isHyper: car.hybird,
                    isNew: car.newCar,
                    defaultColorID: car.colorID,
                    cartDetails: {
                        id: car.productId,
                        name: car.name,
                        price: car.minPrice,
                        brand: car.brand,
                        image: car.image,
                        Tax: car.rateTaxCar,
                        Discount: car.rateCareDiscount,
                        Type: "car",
                    },
                    carOrder: {
                        vehicle: car.productId,
                        group: car.group,
                    },
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <section className="sec" id="vehicles">
            <div className="ctn">
                <div className="stag">{trans("home:subtitle")}</div>
                <h2 className="sh">
                    {trans("home:titlePage").split(' ').slice(0, -2).join(' ')}
                    {' '}
                    <span className="gn">
                        {trans("home:titlePage").split(' ').slice(-2).join(' ')}
                    </span>
                </h2>

                <div className="vtabs">
                    <button className={`vtab ${carFilter === null ? 'on' : ''}`} onClick={() => filterCars(null)}>
                        <svg viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /></svg>
                        {trans("inputs:all")}
                    </button>
                    {brands?.map((brand, index) => (
                        <button key={index} className={`vtab ${carFilter === brand.name ? 'on' : ''}`} onClick={() => filterCars(brand.name)}>
                            {brand.name}
                        </button>
                    ))}
                </div>

                <div className="v-swiper-container">
                    <Swiper
                        spaceBetween={14}
                        slidesPerView={1.5}
                        navigation
                        pagination={{ clickable: true }}
                        breakpoints={{
                            640: { slidesPerView: 2.2 },
                            1024: { slidesPerView: 3.2 },
                            1280: { slidesPerView: 4 }
                        }}
                        className="v-swiper"
                    >
                        {filteredCars.map((car, index) => {
                            const carLink = "/" + lang + "/vehicles/" + slugCombine(car.brand, car.otherBrand) + '/' + car.group + "/" + car.year;
                            return (
                                <SwiperSlide key={index}>
                                    <div className="vc" onClick={() => (window.location.href = carLink)}>
                                        <div className="vc-img">
                                            {car.hybird && <span className="vc-type">{trans("vehicales:veh-hybrid")}</span>}
                                            <button className="vc-fav" onClick={(e) => { e.stopPropagation(); }}>
                                                <svg viewBox="0 0 24 24">
                                                    <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
                                                </svg>
                                            </button>
                                            <img src={config.FilePathURL + car.image} alt={car.name} />
                                        </div>
                                        <div className="vc-body">
                                            <div className="vc-name">{car.name}</div>
                                            <div className="vc-specs">
                                                {/* <span className="vc-spec">
                                                    <svg viewBox="0 0 24 24">
                                                        <circle cx="12" cy="12" r="10" />
                                                        <polyline points="12 6 12 12 16 14" />
                                                    </svg>
                                                    {car.year}
                                                </span> */}
                                            </div>
                                            <div className="vc-foot">
                                                {/* <div className="vc-price">
                                                    <Price price={car.minPrice} />
                                                </div> */}
                                                <div className="flex gap-2">
                                                    <button className="vc-cart" onClick={(e) => handleBuyNow(e, car)}>
                                                        <img src="/assets/icons/cart.svg" width={18} height={18} className="filter-primary" alt="" />
                                                    </button>
                                                    <button className="vc-go">
                                                        <svg viewBox="0 0 24 24">
                                                            <line x1="5" y1="12" x2="19" y2="12" />
                                                            <polyline points="12 5 19 12 12 19" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>

                <div className="vc-more">
                    <Link to={"/VehicleOnline"} style={{ textDecoration: 'none' }}>
                        <span style={{ border: '1.5px solid rgba(0, 0, 0, .08)', padding: '12px 28px', borderRadius: '12px', fontWeight: 700, fontSize: '13px', color: 'var(--t2)', display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                            {trans("common:show-more")}
                            <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" fill="none" strokeWidth="2.5"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>
                        </span>
                    </Link>
                </div>
            </div>
        </section>
    );
}